/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelAd } from '../models/ChannelAd';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdChannelsService {
    /**
     * Add an ad channel
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns ChannelAd Successfully fetched ad channel
     * @throws ApiError
     */
    public static postChannelAd(
        workspaceId: string,
        requestBody: {
            name: string;
            icon: string;
            ad_platform: string;
            ad_account_id: string;
        },
    ): CancelablePromise<ChannelAd> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/channel-ad',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error occured`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Gets an ad channel
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns ChannelAd Successfully fetched channel
     * @throws ApiError
     */
    public static getChannelAd(
        id: string,
        workspaceId: string,
    ): CancelablePromise<ChannelAd> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/channel-ad/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Channel not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes ad channel
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted channel
     * @throws ApiError
     */
    public static deleteChannelAd(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/channel-ad/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Channel not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a ad channel
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully updated channel
     * @throws ApiError
     */
    public static patchChannelAd(
        id: string,
        workspaceId: string,
        requestBody: {
            name?: string;
            icon?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/channel-ad/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Channel not found`,
                500: `Internal server error`,
            },
        });
    }
}
